export default __webpack_public_path__ + "static/media/480_dummy2016-baeckerei01-mobile-de.92b9e01e.png";